(ns hai.ui.components.chip
  "The one removable-chip pattern: a sage capsule of optional glyph, label, and —
   when removable — a full-height × cell divided off by a border. Purely
   presentational; tag, link, contact (and any future) chips compose it with
   their own glyph, label element, and remove behaviour."
  (:require
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(o/defstyled entity-chip :span
  {:display "inline-flex" :align-items "stretch"
   :max-width "100%"
   :border-radius "6px" :overflow "hidden"
   :background t/--card-sage-light
   :color t/--card-forest
   :font-size "12px" :font-weight "600" :line-height "1"}
  [:.chip-glyph
   {:display "inline-flex" :align-items "center"
    :padding-left "10px"
    :flex "0 0 auto"}
   [:svg {:width "13px" :height "13px" :fill "currentColor"}]]
  ;; inline-block (not flex) so a label passed as an element — an anchor, a
  ;; tooltip-wrapped span — stays inline content and the ellipsis still applies.
  [:.chip-label
   {:display "inline-block"
    :padding "4px 10px"
    :min-width "0"
    :overflow "hidden" :text-overflow "ellipsis" :white-space "nowrap"}]
  [:&.has-glyph [:.chip-label {:padding-left "5px"}]]
  [:.chip-remove
   {:display "grid" :place-items "center"
    :width "22px" :flex "0 0 auto"
    :padding "0"
    :border-top "0" :border-right "0" :border-bottom "0"
    :border-left-width "1px" :border-left-style "solid"
    :border-left-color t/--card-forest-14
    :background "transparent"
    :color t/--card-forest
    :cursor "pointer"
    :font-family "inherit" :font-size "15px" :line-height "1"
    :transition "background 120ms ease"}
   [:&:hover {:background t/--card-sage}]]
  ;; `:variant :warning` — for a chip whose subject is time-sensitive, so it
  ;; doesn't read as the same kind of thing as a neutral sage one. Amber, not
  ;; red: a state to notice, not an error. 5.45:1 on the card surface.
  [:&.warning
   {:background t/--card-warning-12
    :color t/--card-warning-text}
   [:.chip-remove
    {:border-left-color "rgba(122,85,0,0.20)"
     :color t/--card-warning-text}
    [:&:hover {:background "rgba(176,122,0,0.18)"}]]]
  ([{:keys [glyph label remove-label on-remove variant]}]
   [:<>
    {:class (cond-> []
              glyph   (conj "has-glyph")
              variant (conj (name variant)))}
    (when glyph [:span.chip-glyph glyph])
    [:span.chip-label label]
    (when on-remove
      [:button.chip-remove
       {:type "button" :aria-label remove-label
        ;; Don't take focus on click — losing it from the host (e.g. a note's
        ;; textarea) would end editing as the chip unmounts.
        :on-mouse-down #(.preventDefault %)
        :on-click (fn [e] (.stopPropagation e) (on-remove))}
       "×"])]))
